/**
 * API payloads distinguish safe reader text from exact preserved text. When
 * `display_text` is present, even an empty value is intentional and must never
 * fall back to `exact_text`. Only legacy payloads without that property use
 * the exact text as their display value.
 */
export function displayText(segment) {
  if (!segment || typeof segment !== "object") return "";
  if (Object.hasOwn(segment, "display_text")) {
    return segment.display_text ?? "";
  }
  return segment.exact_text ?? "";
}

export function hasDisplayText(segment) {
  return Boolean(String(displayText(segment)).trim());
}
